import { Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { RegulacionPlazaService } from 'src/app/core/services/regulacion-plaza.service';
import { RegulacionPlazaModel } from 'src/app/core/models/regulacion-plaza.model';
import { take, takeWhile } from 'rxjs/operators';
import { OcupacionZonaModel } from 'src/app/core/models/ocupacion-zona.model';
import { SesionEstacionamientoService } from 'src/app/core/services/sesion-estacionamiento.service';
import { HistoricoSesionEstacionamientoService } from 'src/app/core/services/historico-sesion-estacionamiento.service';
import { FilterInformesModel } from 'src/app/core/models/filter-informes.model';
import { InformeModel } from 'src/app/core/models/informe.model';
import { Utilities } from 'src/app/theme/utils/utilities.class';
import { RegulacionPlazaInformePlanoModel } from 'src/app/core/models/regulacion-plaza-informe-plano.model';
import { UsoPlazaModel } from 'src/app/core/models/uso-plaza.model';
import { TranslateService } from '@ngx-translate/core';
import { RutasService } from 'src/app/core/services/rutas.service';
import { features } from 'process';
import { OpenStreetMapNominatimService } from 'src/app/core/services/open-street-map-nominatim.service';
import { OsrmService } from 'src/app/core/services/osrm.service';
import { OsrmModel } from 'src/app/core/models/osrm.model';
import { OlMapPlazasComponent } from 'src/app/theme/components/ol-map-plazas/ol-map-plazas.component';
import { GeometryOsrmModel } from 'src/app/core/models/geometry-osrm.model';
import { BaseComponent } from '../../area-privada/components/base/base.component';
import { NgForm } from '@angular/forms';
import { OlMapBarriosComponent } from 'src/app/theme/components/ol-map-barrios/ol-map-barrios.component';
import { OlMapPlazaDiponibilidadSemanalComponent } from 'src/app/theme/components/ol-map-plaza-diponibilidad-semanal/ol-map-plaza-diponibilidad-semanal.component';
import { FeatureCallesEsriModel } from 'src/app/core/models/feature-calles-esri.model';

@Component({
  selector: 'dum-plano',
  templateUrl: './plano.component.html',
  styleUrls: ['./plano.component.scss']
})
export class PlanoComponent extends BaseComponent implements OnInit {
  @ViewChildren('formRoute') formRoute: NgForm;
  @ViewChild(OlMapPlazasComponent) olMapPlazasComponent: OlMapPlazasComponent;
  @ViewChild(OlMapBarriosComponent) olMapBarriosComponent: OlMapBarriosComponent;
  @ViewChild(OlMapPlazaDiponibilidadSemanalComponent) olMapPlazaDiponibilidadSemanalComponent: OlMapPlazaDiponibilidadSemanalComponent;

  regulacionPlazas: RegulacionPlazaModel[] = [];
  regulacionPlazaInforme: RegulacionPlazaInformePlanoModel[] = [];
  alive = true;
  mapSelected: any;
  loadingSpinner: boolean = true;
  showRightButton: boolean;
  showLeftButton: boolean;
  showPanel: boolean;
  mostrarColoresEstadoPlaza: boolean = true;
  optionMapas = [
    { field: 'estado_plazas', header: 'Estado Plazas' },
    { field: 'estado_barrios', header: 'Estado Barrios' },
    { field: 'estado_plaza_por_duracion_ultima_semana', header: 'Predicción de ocupación diaria' }
  ];
  datosSubBarrios: OcupacionZonaModel[] = [];
  ultimaSemana: Date = this.getFechaUltimaSemana(-7);
  informeSesionesUltimaSemana: InformeModel;
  origen: any;
  origenNp: any;
  destino: any;
  destinoNp: any;
  calles: any[] = [];
  numerosPoliciaOrigen: any[] = [];
  numerosPoliciaDestino: any[] = [];
  title: string = this.translateSevice.instant('GLOBAL.VISUALIZACION.PLAZAS.TIEMPO.REAL');
  ruta: OsrmModel;
  hasRouter: boolean;
  geometryRoute: string;
  geometryOrigen: number[];
  geometryDestino: number[];
  latInicio: number;
  lonInicio: number;
  inputSelected: string;
  constructor(
    private regulacionService: RegulacionPlazaService,
    private sesionEstacionamientoService: SesionEstacionamientoService,
    private historicoSesionEstacionamientoService: HistoricoSesionEstacionamientoService,
    private translateSevice: TranslateService,
    private rutasService: RutasService,
    private openStreetMapNominatimService: OpenStreetMapNominatimService,
    private osrmService: OsrmService) {
    super();
    this.regulacionService.getAll()
      .pipe(takeWhile(() => this.alive))
      .subscribe((regulacionPlazas) => {
        this.regulacionPlazas = regulacionPlazas;
        this.loadingSpinner = false;
        this.getInforme();
      });
    this.mapSelected = { field: 'estado_plazas', header: 'Estado Plazas' };
    this.sesionEstacionamientoService.startPanelControl();
    this.sesionEstacionamientoService.datosPanelControl$
      .pipe(takeWhile(() => this.alive))
      .subscribe((panelControl) => this.datosSubBarrios = panelControl.ocupacion);
  }

  ngOnInit(): void {
    this.showRightButton = false;
    this.showLeftButton = true;
    this.showPanel = true;
  }

  selectedInputs(selected) {
    this.inputSelected = selected;
    this.clearFromMapCoordinates();
  }

  onSelect($event, selected) {
    if (selected === 'origen') {
      this.numerosPoliciaOrigen = [];
      this.origenNp = null;
    } else {
      this.numerosPoliciaDestino = [];
      this.destinoNp = null;
    }
    this.rutasService.autoSearchNumeros($event.codAyto)
      .pipe(takeWhile(() => this.alive))
      .subscribe((result) => {
        if (result.features.length > 0) {
          const myArray = [];
          result.features.forEach((numero) => {
            myArray.push({
              label: numero.attributes.NPOL_ + ' ' + numero.attributes.DUPLI_,
              value: {
                codAyto: numero.attributes.IDAYTO,
                nomCalle: numero.attributes.NPOL_,
                tipoVia: numero.attributes.DUPLI_,
                x: numero.geometry.x,
                y: numero.geometry.y
              }
            });
          });
          if (selected === 'origen') {
            this.numerosPoliciaOrigen = myArray;
            this.origenNp = this.numerosPoliciaOrigen[0].value;
          } else {
            this.numerosPoliciaDestino = myArray;
            this.destinoNp = this.numerosPoliciaDestino[0].value;
          }
          this.onSelectNumeroPolicia(selected);
        } else {
          if ($event.x !== -1 || $event.y !== -1) {
            const np = {
              codAyto: $event.codAyto,
              nomCalle: '',
              tipoVia: '',
              x: $event.x,
              y: $event.y
            };
            if (selected === 'origen') {
              this.origenNp = np;
            } else {
              this.destinoNp = np;
            }
            this.onSelectNumeroPolicia(selected);
          } else {
            this.dumToast.add({ severity: 'error', summary: 'Error', detail: 'No encontrado números' });
          }
        }
      });
  }

  onSelectNumeroPolicia(selected) {
    if (selected === 'origen') {
      this.getCurrentMapComponent().updateInitPoint([this.origenNp.x, this.origenNp.y]);
    } else {
      this.getCurrentMapComponent().updateEndPoint([this.destinoNp.x, this.destinoNp.y]);
    }
  }

  getInforme() {
    const filterInforme = new FilterInformesModel();
    filterInforme.fechaDesde = this.ultimaSemana;
    this.historicoSesionEstacionamientoService.generarInforme(filterInforme)
      .pipe(takeWhile(() => this.alive))
      .subscribe((informe) => {
        this.informeSesionesUltimaSemana = informe;
        this.preparacionDatosDisponibilidadUltSemana();
      });
  }

  changeMap() {
    if (this.mapSelected.field === 'estado_plazas') {
      this.title = this.translateSevice.instant('GLOBAL.VISUALIZACION.PLAZAS.TIEMPO.REAL');
    } else if (this.mapSelected.field === 'estado_barrios') {
      this.title = this.translateSevice.instant('GLOBAL.VISUALIZACION.ZONAS.TIEMPO.REAL');
    } else if (this.mapSelected.field === 'estado_plaza_por_duracion_ultima_semana') {
      this.title = this.translateSevice.instant('GLOBAL.VISUALIZACION.PLAZAS.DISPONIBILIDAD.SEMANAL.TIEMPO.REAL');
    }
    this.limpiarForm();
  }

  preparacionDatosDisponibilidadUltSemana() {
    this.regulacionPlazas.forEach((regulacion) => {
      let existUsoPlaza = false;
      if (this.informeSesionesUltimaSemana.usoPlazaIndividual &&
        Array.isArray(this.informeSesionesUltimaSemana.usoPlazaIndividual)) {
        this.informeSesionesUltimaSemana.usoPlazaIndividual.forEach((usoPlaza) => {
          if (regulacion.id === usoPlaza.idRegulacion) {
            const newRegulacionPlazaInforme = new RegulacionPlazaInformePlanoModel();
            newRegulacionPlazaInforme.regulacionPlaza = regulacion;
            newRegulacionPlazaInforme.usoPlaza = usoPlaza;
            this.regulacionPlazaInforme.push(newRegulacionPlazaInforme);
            existUsoPlaza = true;
          }
        });
        if (!existUsoPlaza) {
          const newRegulacionPlazaInforme = new RegulacionPlazaInformePlanoModel();
          const newUsoPlaza = new UsoPlazaModel();
          newUsoPlaza.ocupacionMediaSemanal = 0;
          newRegulacionPlazaInforme.regulacionPlaza = regulacion;
          newRegulacionPlazaInforme.usoPlaza = newUsoPlaza;
          this.regulacionPlazaInforme.push(newRegulacionPlazaInforme);
        }
      }
    });
  }

  getFechaUltimaSemana(days) {
    const fecha = new Date();
    fecha.setDate(fecha.getDate() + days);
    return fecha;
  }

  devolverFechaFormateada(fecha) {
    const day = fecha.getDate();
    const month = fecha.getMonth() + 1;
    const year = fecha.getFullYear();
    return day + '/' + month + '/' + year;
  }

  clearFromMapCoordinates() {
    this.getCurrentMapComponent().updateRoute(null, null, null);
  }

  private continueCalcRoute(coordenadasOrigen: number[], coordenadasDestino: number[]) {
    if (coordenadasOrigen && coordenadasDestino) {
      this.loadingSpinner = true;
      this.osrmService.getRoute(coordenadasOrigen, coordenadasDestino)
        .pipe(take(1))
        .subscribe((osrmResult) => {
          this.ruta = osrmResult;
          this.geometryOrigen = osrmResult.waypoints[0].location;
          this.geometryDestino = osrmResult.waypoints[1].location;
          this.geometryRoute = osrmResult.routes[0].geometry;
          this.latInicio = osrmResult.routes[0].legs[0].steps[Math.floor(osrmResult.routes[0].legs[0].steps.length / 2)].maneuver.location[1];
          this.lonInicio = osrmResult.routes[0].legs[0].steps[Math.floor(osrmResult.routes[0].legs[0].steps.length / 2)].maneuver.location[0];
          this.hasRouter = true;
          this.loadingSpinner = false;
          this.getCurrentMapComponent().updateRoute(this.geometryRoute, this.geometryOrigen, this.geometryDestino);
        });
    }
  }

  calcularRuta() {
    this.ruta = null;
    this.continueCalcRoute([this.origenNp.x, this.origenNp.y],
      [this.destinoNp.x, this.destinoNp.y]);
  }

  getPositionUser() {
    navigator.geolocation.getCurrentPosition((result) => {
      this.setStartEndPointByCoordinate({
        coordinate: [result.coords.longitude, result.coords.latitude],
        isOrigin: true
      }, '[loc]');
    });
  }

  getCoordinate(calle: FeatureCallesEsriModel) {
    let x = -1;
    let y = -1;
    const c = calle as any;
    if ((c.geometry) &&
      (c.geometry.paths) &&
      Array.isArray(c.geometry.paths) &&
      c.geometry.paths.length > 0) {
      const coords = c.geometry.paths[0];
      if (Array.isArray(coords) &&
        coords.length > 0) {
        x = coords[0][0];
        y = coords[0][1];
      }
    }
    return [x, y];
  }

  buscarCalle(event, origin: boolean, isLocation?: boolean) {
    if (origin) {
      this.origenNp = null;
    } else {
      this.destinoNp = null;
    }
    const newArrCalle = [];
    this.rutasService.autoSearchCalles(event.query.toLowerCase())
      .pipe(take(1))
      .subscribe((result) => {
        if (result.features.length > 0) {
          result.features.forEach((calle) => {
            const coords = this.getCoordinate(calle);
            newArrCalle.push({
              codAyto: calle.attributes.COD_AYTO,
              nomCalle: calle.attributes.NOM_CALLE,
              tipoVia: calle.attributes.TIPO_VIA_T,
              tipoYCalle: calle.attributes.TIPO_VIA_T + ' ' + calle.attributes.NOM_CALLE,
              x: coords[0],
              y: coords[1],
            });
          });
          this.calles = newArrCalle;
        } else {
          if (isLocation) {
            this.origen = '';
          }
          if (('[coord]'.indexOf(event.query.toLowerCase()) !== 0) &&
            ('[loc]'.indexOf(event.query.toLowerCase()) !== 0)) {
            this.dumToast.add({ severity: 'error', summary: 'Error', detail: 'Calle no encontrada' });
          }
          this.calles = newArrCalle;
        }
      });
  }

  getCurrentMapComponent() {
    if (this.mapSelected.field === 'estado_plazas') {
      return this.olMapPlazasComponent;
    } else if (this.mapSelected.field === 'estado_barrios') {
      return this.olMapBarriosComponent;
    } else if (this.mapSelected.field === 'estado_plaza_por_duracion_ultima_semana') {
      return this.olMapPlazaDiponibilidadSemanalComponent;
    }
  }

  getDestOrigClickEx(event) {
    this.setStartEndPointByCoordinate(event, '[coord]');
  }

  setStartEndPointByCoordinate(event, tag) {
    const np = {
      codAyto: 0,
      nomCalle: '',
      tipoVia: '',
      x: event.coordinate[0],
      y: event.coordinate[1]
    };
    const c = {
      codAyto: 0,
      nomCalle: '',
      tipoVia: '',
      tipoYCalle: tag
    };
    if (event.isOrigin) {
      this.origenNp = np;
      this.origen = c;
      this.getCurrentMapComponent().updateInitPoint([this.origenNp.x, this.origenNp.y]);
    } else {
      this.destinoNp = np;
      this.destino = c;
      this.getCurrentMapComponent().updateEndPoint([this.destinoNp.x, this.destinoNp.y]);
    }
  }

  cambiarOrdenOrigDest() {
    const oldOrigen = this.origen;
    const oldOrigenNp = this.origenNp;
    this.origen = this.destino;
    this.origenNp = this.destinoNp;
    this.destino = oldOrigen;
    this.destinoNp = oldOrigenNp;
  }
  ocultarPanel() {
    this.showPanel = false;
    this.showLeftButton = false;
    this.showRightButton = true;
  }

  mostrarPanel() {
    this.showPanel = true;
    this.showRightButton = false;
    this.showLeftButton = true;
  }

  limpiarForm() {
    this.loadingSpinner = true;
    this.ruta = null;
    this.hasRouter = false;
    this.geometryRoute = null;
    this.geometryDestino = [];
    this.geometryOrigen = [];
    this.destino = '';
    this.origen = '';
    this.origenNp = null;
    this.destinoNp = null;
    this.loadingSpinner = false;
  }
  ocultarLeyendaEstadoPlazas() {
    this.mostrarColoresEstadoPlaza = false;
  }
  mostrarLeyendaEstadoPlazas() {
    this.mostrarColoresEstadoPlaza = true;
  }
}
